import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { UserListResponse } from '../../structs/user-list.response';
import { ReturnStruct } from '../../structs/return.struct';
import { SimulatorAccessStatusResponse } from '../../responses/platform/simulator-access-status.response';
import { PublicationProfileRequest } from '../../../constants/user-publication-profile.constants';

@Injectable({ providedIn: 'root' })
export class UserService extends CommonService {
  private base = environment.urlApiPlatform + 'User/';
  constructor(private http: HttpClient) { super(); }

  /** Lista de usuários ativos para seleção (ajuste o endpoint se necessário) */
  public listActive(includeLogedUser: boolean = false): Observable<UserListResponse> {
    return this.http
      .get<UserListResponse>(this.base + 'listActive?includeLogedUser=' + includeLogedUser, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Status de acesso do usuário logado ao simulador (dados complementares + livro publicado) */
  public getSimulatorAccessStatus(): Observable<SimulatorAccessStatusResponse> {
    return this.http
      .get<SimulatorAccessStatusResponse>(this.base + 'simulatorAccessStatus', this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Salva os dados complementares de publicação do usuário logado */
  public savePublicationProfile(profile: PublicationProfileRequest): Observable<ReturnStruct> {
    return this.http
      .post<ReturnStruct>(this.base + 'publicationProfile/save', profile, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
